import {request, requestHeader} from './api';
import {updateQuery} from "@services/helper";

export const get = (data={}) => {
    return request(`/admin/benefit-limits?${new URLSearchParams(data).toString()}`, {
        method: 'GET',
    });
};

export const getHeadersLimits = ({benefitId, page, size=50, sort}) => {
    return requestHeader(`/admin/benefit-limits${updateQuery({benefitId, page, size, sort})}`, {});
};


export const getHeaders = (data, page=0) => {
    return requestHeader(`/admin/barcodes?${new URLSearchParams(data).toString()}&page=${page}`, {});
};

export const create = (barcode) => {
    return request(`/admin/benefit-limits`, {
        method: 'POST',
        body: JSON.stringify(barcode),
    });
};

export const update = (id, benefit) => {
    return request(`/admin/benefit-limits/${id}/amount`, {
        method: 'PATCH',
        body: JSON.stringify(benefit),
    });
};

export const remove = (id, benefit) => {
    return request(`/admin/benefit-limits/${id}`, {
        method: 'DELETE',
    });
};
